import type { ReactNode } from 'react'

import { Container } from './Container'
import { IconWrapper } from './IconWrapper'
import { Title } from './Title'

type Props = {
	title: ReactNode
	icon?: ReactNode
	children?: ReactNode
}

export const BottomCard = ({ title, icon, children }: Props) => (
	<Container>
		{icon && <IconWrapper>{icon}</IconWrapper>}
		<div>
			<Title>{title}</Title>
			{children}
		</div>
	</Container>
)
